import { QueryClient } from "@tanstack/react-query";

/**
 * The single app-wide react-query client. Extracted out of `main.tsx` so
 * non-component modules (e.g. the role-preview store) can bust event-scoped
 * caches when entering/leaving preview mode without prop-drilling the client.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        // Wherever the status sits: a client re-wrap and `unwrap` put it on
        // `status`, a handler's ServerError on `httpStatus`, raw axios on
        // `response.status`. Reading only the last never saw the first two.
        const shaped = error as
          | { status?: unknown; httpStatus?: unknown; response?: { status?: unknown } }
          | null
          | undefined;
        const status = shaped?.status ?? shaped?.httpStatus ?? shaped?.response?.status;
        // Asking again cannot change the answer to these — and a 429 asked
        // again is the traffic the limit is there to stop (M-146).
        if (status === 401 || status === 403 || status === 404 || status === 429) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
    },
  },
});
